<template>
  <vs-popup class="holamundo" :active.sync="localShow" :buttons-hidden="true">
    <div class="text-center px-6 py-10 md:p-10">
      <div class="popup-body md:popup-body mb-4 ml-0">
        <h2>Congratulations!</h2><br>
        <p>As a participant in the Athar festival, you've received a</p><br>
        <h1>$50 gift</h1><br>
      </div>

      <img class="text-center" src="@/assets/images/ATHAR-popup.png" />
      <div class="popup-body md:popup-body mb-4 ml-0">
        <br>
        <p>Start your advertising campaign now and succeed!</p>
      </div>

      <vs-button class="ok-btn md:ok-btn" @click="hidePopup">{{ $t('Launch Your Campaign') }}</vs-button>
    </div>
  </vs-popup>
</template>

<script>
export default {
  name: 'speakol-athar-bonus-popup',

  props: {
    show: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      localShow: this.show
    }
  },
  watch: {
    show (newVal) {
      this.localShow = newVal
    },
    localShow (newVal) {
      if (!newVal) {
        this.$emit('hide-bonus-popup')
      }
    }
  },
  methods: {
    hidePopup () {
      this.localShow = false
    }
  },

  beforeDestroy () {
    this.$emit('hide-bonus-popup')
  }
}
</script>

<style scoped lang="scss">
.popup-body {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  letter-spacing: 0.1px;
  color: #888888;
}

.md\:popup-body h2 {
  color: #009bde;
}

.md\:popup-body h1 {
  color: #888888;
  font-style: normal;
  font-weight: bold;
  letter-spacing: 0.1px;
}

.ok-btn {
  border-radius: 3px;
  margin-top: 20px;
  height: 40px;
  background: #0092d7;

  @apply w-full;
}

.text-center {
  width: 100%;
  height: auto;
}

@media (min-width: 768px) {
  .md\:ok-btn {
    width: 230px;
  }

  .md\:popup-body {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    text-align: center;
    letter-spacing: 0.1px;
    color: #888888;
  }

  .md\:popup-body h2 {
    color: #009bde;
  }

  .md\:popup-body h1 {
    color: #888888;
    font-style: normal;
    font-weight: bold;
    letter-spacing: 0.1px;
  }

  .text-center {
    width: 100%;
    height: auto;
  }
}

</style>
